// @flow
/**
 * A component that generates extra answers on the frontend.
 * (Usually they are passed from the backend in the modules config).
 *
 * UPD: This component can be deleted at all if we accept this MR.
 */
import React, { useContext } from "react";
import type { AnswerType } from "../../lib/types";
import { MessageTypes } from "../../lib/types";
import { MessageContext } from "./BotMessageGenerator";
import { Answers } from "./Answers";

type Props = {
  answers: Array<AnswerType>,
};

export const ExtraAnswersGenerator = (props: Props) => {
  const answers = props.answers;
  const messageContext = useContext(MessageContext);
  const { messageType, module } = messageContext;

  // const { link_href: moduleLink } = module;

  // if (messageType === MessageTypes.LOCATIONS_MESSAGE) {
  //   // That's first time when we generate the answers on the frontend.
  //   answers = [
  //     {
  //       action: 1,
  //       text: "Back",
  //     },
  //   ];
  //
  //   // TODO testrequired: add extra answer that redirects to another page.
  //   if (moduleLink) {
  //     answers = [
  //       {
  //
  //       },
  //       ...answers
  //     ]
  //   }
  // }

  return <Answers answers={answers} />;
};
